import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    standalone: false
})
export class ConfirmationDialogComponent {

    message: string;
    confirmText?: string;
    cancelText?: string;

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
        this.message = data.message;
        this.confirmText = data.confirmText;
        this.cancelText = data.cancelText;
    }
}

export interface DialogData {
    message: string;
    confirmText?: string;
    cancelText?: string;
}
